module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-up-3402468e7bea24c3e03c24f1b823640e.svg";